import { createContext, useContext } from 'react';
import type { SiteSettings } from '@/services/siteSettings';

export interface SiteSettingsContextValue {
  settings: SiteSettings;
  loading: boolean;
  error: string;
  refreshSettings: () => Promise<SiteSettings>;
  updateSettings: (settings: SiteSettings) => Promise<SiteSettings>;
}

export const SiteSettingsContext = createContext<SiteSettingsContextValue | undefined>(undefined);

export function useSiteSettings() {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used inside SiteSettingsProvider.');
  }
  return context;
}
